var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "team-detail" },
    [
      _vm.nav["back-link"]
        ? _c(
            "z-link",
            {
              staticClass: "team-detail__link",
              attrs: {
                size: "m",
                iconPosition: "left",
                icon: "arrow",
                href: _vm.nav["back-link"],
              },
            },
            [_vm._v(_vm._s(_vm.textDetail.linkText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "team-detail__head u-top-margin--m" }, [
        _vm.data.previewPicture
          ? _c("div", {
              staticClass: "team-detail__image",
              style:
                "background-image: url(" + _vm.data.previewPicture.link + ")",
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "team-detail__person" }, [
          _c(
            "div",
            [
              _c("z-caption", {
                staticClass: "team-detail__name",
                attrs: { tag: "h2", weight: "600" },
                domProps: { innerHTML: _vm._s(_vm.data.name) },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "team-detail__post",
                domProps: { innerHTML: _vm._s(_vm.data.position.value) },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.data.startOfWork.value
            ? _c(
                "p",
                { staticClass: "team-detail__date", attrs: { tag: "span" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.textDetail.work) +
                      " " +
                      _vm._s(_vm.data.startOfWork.value)
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "team-detail__content" },
        [
          _c("z-blockquote", {
            staticClass: "team-detail__quote",
            attrs: {
              author: {
                name: "",
                info: "",
                photo: "",
              },
              text: _vm.data.quote.value,
            },
          }),
          _vm._v(" "),
          _vm.data.historyOfSuccess.value
            ? _c("z-caption", {
                staticClass: "team-detail__story-title",
                attrs: { tag: "h3", weight: "600" },
                domProps: { innerHTML: _vm._s(_vm.textDetail.story) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.data.historyOfSuccess.value
            ? _c("vue-raw", {
                staticClass: "team-detail__story",
                attrs: { raw: _vm.data.historyOfSuccess.value },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.data.video.link || _vm.data.videoLink.value
            ? _c("z-video", {
                staticClass: "team-detail__video",
                attrs: {
                  autoplay: false,
                  src: _vm.data.video.link || _vm.data.videoLink.value,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.nav.prev || _vm.nav.next
        ? _c("page-changer", {
            staticClass: "team-detail__footer",
            attrs: {
              data: {
                next: {
                  name: _vm.nav.next ? _vm.nav.next.name : "",
                  url: _vm.nav.next ? _vm.nav.next.url : "",
                },
                prev: {
                  name: _vm.nav.prev ? _vm.nav.prev.name : "",
                  url: _vm.nav.prev ? _vm.nav.prev.url : "",
                },
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }